import template from './eSign.template.html';

export default {
  bindings: {},
  controller: class controller {
    constructor($sce, $timeout, $mdDialog, eventService) {
      'ngInject';

      const ctrl = this;

      ctrl.initialize = () => {
        ctrl.destroyWatch = eventService.onDialogESign((params) => {
          $mdDialog
            .show({
              targetEvent: params?.event || '',
              locals: {
                url: params?.url || ''
              },
              template,
              controllerAs: '$ctrl',
              multiple: true,
              controller(url) {
                const self = this;
                self.url = $sce.trustAsResourceUrl(url);

                self.cancel = () => {
                  $mdDialog.cancel();
                };
              }
            })
            .then(() => {
              //
            });
        });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
